import Drawer from '@mui/material/Drawer'
import type { ReactNode } from 'react'

import { colorTokens } from '../tokens/colors.ts'
import { APP_BAR_HEIGHT_PX } from './app-bar-height'

const DRAWER_WIDTH = 500
const DRAWER_PAPER_GRADIENT = `linear-gradient(to left, ${colorTokens.global.primary[50]}, ${colorTokens.semantic.brand.base.white} 137.21%)`

export type KestrixDrawerProps = {
  open: boolean
  onClose: () => void
  children?: ReactNode
  /** Test id for the drawer panel. Defaults to "kestrix-drawer". */
  dataTestId?: string
}

export const KestrixDrawer = ({
  open,
  onClose,
  children,
  dataTestId = 'kestrix-drawer'
}: KestrixDrawerProps) => (
  <Drawer
    anchor="right"
    open={open}
    onClose={onClose}
    // persistent + fixed paper keeps the panel below the app bar with inset gaps;
    // temporary would use MUI's full-viewport backdrop and override our top offset.
    variant="persistent"
    slotProps={{
      paper: {
        'data-testid': dataTestId
      } as Record<string, unknown>
    }}
    sx={{
      width: open ? DRAWER_WIDTH : 0,
      flexShrink: 0,
      position: 'relative',
      '& .MuiDrawer-paper': {
        width: DRAWER_WIDTH,
        boxSizing: 'border-box',
        border: `1px solid ${colorTokens.global.neutral[100]}`,
        borderRadius: '8px',
        background: DRAWER_PAPER_GRADIENT,
        boxShadow: '0px 24px 48px -8px rgba(88,88,88,0.12), 0px 2px 4px 0px rgba(88,88,88,0.04)',
        zIndex: (theme) => theme.zIndex.drawer,
        position: 'fixed',
        top: APP_BAR_HEIGHT_PX,
        bottom: 8,
        right: 8,
        height: 'auto'
      }
    }}
  >
    {children}
  </Drawer>
)
